export default "__VITE_ASSET__gekz2Ess__"